<template>
  <div class="spinner-container d-flex justify-content-center align-items-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
};
</script>

<style scoped>
.spinner-container {
  height: 100%;
}
.spinner-border {
  width: 3rem;
  height: 3rem;
  border-width: .3rem;
}
</style>
